import axios from 'axios';
import axiosRetry from 'axios-retry';

class API {
  constructor() {
    axiosRetry(
      axios,
      {
        retries: 3,
        retryDelay: (retryCount) => {
          return retryCount * 1000;
        }
      });
  }

  editChild(childId, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/children/update/session/' + childId, data, {qs: 1})
        .then(resp => {
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch(() => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }

  removeChild(id) {
    return new Promise((resolve, reject) => {
      const data = {ids: [id]};
      axios.delete('/api/children/', {data: data})
        .then(resp => {  // APIException ends up here with resp.data.status = 0
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch((error) => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }

  bulkEditSettings(ids, data) {
    return new Promise((resolve, reject) => {
      const strIds = ids.join(',');
      axios.post('/api/children/updateGradeInfo/' + strIds, data, {qs: 1})
        .then(resp => {
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch(() => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }

  bulkRemove(ids) {
    return new Promise((resolve, reject) => {
      const data = {ids: ids};
      axios.delete('/api/children/', {data: data})
        .then(resp => {
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch(() => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }

  bulkAddChildren(names, grade) {
    console.log('in bulk add api?');
    let children = [];
    names.forEach((name) => {
      const child = {
        childName: name,
        childGrade: grade
      };
      children.push(child);
    });

    return new Promise((resolve, reject) => {
      axios.post('/api/children', {children: children}, {qs: 1})
        .then(resp => {
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch(() => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }
}


// Singleton
let api = new API();
export default api;
